import { useState, useRef, useEffect } from "react";

const MY_CITIES = ["北京", "南京", "上海", "广州", "深圳", "成都", "天津", "杭州", "武汉", "重庆", "西安"];

const CITIES_BY_LETTER: Record<string, string[]> = {
  A: ["安庆", "安阳", "鞍山", "安顺", "安康"],
  B: ["北京", "保定", "包头", "宝鸡", "本溪", "滨州", "白银", "巴中", "蚌埠"],
  C: ["成都", "长沙", "重庆", "长春", "沧州", "承德", "常州", "常德", "朝阳", "赤峰", "崇左"],
  D: ["大连", "大同", "大庆", "东营", "德阳", "德州", "丹东", "东莞"],
  E: ["鄂尔多斯", "恩施", "鄂州"],
  F: ["福州", "佛山", "抚顺", "阜阳", "阜新", "防城港"],
  G: ["广州", "贵阳", "桂林", "赣州", "广元", "固原", "广安", "果洛"],
  H: ["哈尔滨", "海口", "合肥", "杭州", "呼和浩特", "惠州", "邯郸", "湖州", "汉中", "衡阳", "菏泽", "黄石"],
  J: ["济南", "济宁", "金华", "锦州", "九江", "吉林", "嘉兴", "揭阳", "荆州", "晋城", "焦作", "景德镇"],
  K: ["昆明", "开封", "喀什", "克拉玛依"],
  L: ["兰州", "柳州", "洛阳", "丽江", "临沂", "廊坊", "乐山", "丽水", "连云港", "凉山"],
  M: ["绵阳", "马鞍山", "茂名", "眉山", "梅州", "牡丹江"],
  N: ["南京", "南昌", "南宁", "南通", "南充", "宁波", "南阳", "宁德"],
  P: ["攀枝花", "盘锦", "莆田", "平顶山", "普洱", "萍乡"],
  Q: ["青岛", "泉州", "秦皇岛", "黔南", "清远", "曲靖", "衢州"],
  R: ["日照", "荣成", "日喀则"],
  S: ["上海", "深圳", "沈阳", "石家庄", "苏州", "绍兴", "汕头", "三亚", "三明", "汕尾", "朔州", "宿迁"],
  T: ["天津", "太原", "唐山", "泰安", "台州", "通化", "铜仁", "通辽", "天水"],
  W: ["武汉", "无锡", "温州", "乌鲁木齐", "威海", "潍坊", "芜湖", "吴忠", "文山"],
  X: ["西安", "厦门", "徐州", "西宁", "湘潭", "咸阳", "新乡", "襄阳", "忻州", "宣城", "锡林郭勒"],
  Y: ["银川", "烟台", "宜昌", "宜宾", "岳阳", "延安", "延边", "玉林", "玉溪"],
  Z: ["郑州", "珠海", "中山", "湛江", "张家口", "张家界", "株洲", "遵义", "自贡", "漳州", "张掖", "舟山", "湛江"],
};

const PROVINCES = [
  { name: "北京", cities: ["北京"] },
  { name: "上海", cities: ["上海"] },
  { name: "天津", cities: ["天津"] },
  { name: "重庆", cities: ["重庆"] },
  { name: "广东", cities: ["广州", "深圳", "东莞", "佛山", "珠海", "中山", "惠州", "汕头", "茂名", "湛江", "清远", "汕尾", "揭阳"] },
  { name: "江苏", cities: ["南京", "苏州", "无锡", "常州", "南通", "连云港", "宿迁", "淮安", "盐城", "扬州", "镇江", "泰州", "徐州"] },
  { name: "浙江", cities: ["杭州", "宁波", "温州", "金华", "嘉兴", "绍兴", "台州", "湖州", "丽水", "舟山", "衢州"] },
  { name: "四川", cities: ["成都", "绵阳", "德阳", "乐山", "宜宾", "泸州", "自贡", "攀枝花", "广元", "南充", "广安", "达州", "眉山", "雅安", "巴中"] },
  { name: "湖北", cities: ["武汉", "宜昌", "荆州", "黄石", "襄阳", "鄂州", "十堰", "荆门", "孝感", "黄冈", "咸宁", "随州", "恩施"] },
  { name: "湖南", cities: ["长沙", "株洲", "湘潭", "岳阳", "常德", "衡阳", "邵阳", "郴州", "永州", "怀化", "益阳", "娄底", "张家界"] },
  { name: "山东", cities: ["济南", "青岛", "烟台", "潍坊", "临沂", "济宁", "东营", "威海", "淄博", "泰安", "德州", "滨州", "菏泽", "聊城", "日照", "莱芜"] },
  { name: "陕西", cities: ["西安", "咸阳", "宝鸡", "延安", "汉中", "榆林", "渭南", "铜川", "安康", "商洛"] },
  { name: "河南", cities: ["郑州", "洛阳", "开封", "南阳", "焦作", "新乡", "平顶山", "安阳", "驻马店", "许昌", "信阳", "周口", "商丘"] },
  { name: "河北", cities: ["石家庄", "唐山", "保定", "廊坊", "邯郸", "张家口", "秦皇岛", "承德", "沧州", "衡水", "邢台"] },
  { name: "辽宁", cities: ["沈阳", "大连", "鞍山", "抚顺", "本溪", "锦州", "丹东", "营口", "阜新", "辽阳", "盘锦", "朝阳", "铁岭"] },
  { name: "黑龙江", cities: ["哈尔滨", "大庆", "齐齐哈尔", "牡丹江", "佳木斯", "鸡西", "鹤岗", "双鸭山", "七台河", "伊春", "黑河"] },
  { name: "吉林", cities: ["长春", "吉林", "延边", "四平", "通化", "白城", "辽源", "松原", "白山"] },
  { name: "山西", cities: ["太原", "大同", "长治", "临汾", "运城", "晋城", "晋中", "朔州", "忻州", "吕梁", "阳泉"] },
  { name: "安徽", cities: ["合肥", "芜湖", "马鞍山", "蚌埠", "淮南", "阜阳", "宿州", "安庆", "黄山", "六安", "滁州", "淮北", "铜陵", "宣城", "亳州"] },
  { name: "福建", cities: ["福州", "厦门", "泉州", "莆田", "漳州", "三明", "龙岩", "南平", "宁德"] },
  { name: "江西", cities: ["南昌", "九江", "赣州", "景德镇", "萍乡", "上饶", "新余", "宜春", "抚州", "吉安", "鹰潭"] },
  { name: "广西", cities: ["南宁", "柳州", "桂林", "梧州", "北海", "防城港", "钦州", "贵港", "玉林", "百色", "崇左", "河池", "来宾", "贺州"] },
  { name: "云南", cities: ["昆明", "曲靖", "玉溪", "丽江", "普洱", "大理", "文山", "红河", "保山", "西双版纳", "临沧", "楚雄", "昭通", "怒江", "迪庆", "德宏"] },
  { name: "贵州", cities: ["贵阳", "遵义", "六盘水", "安顺", "黔南", "铜仁", "毕节", "黔东南", "黔西南"] },
  { name: "甘肃", cities: ["兰州", "天水", "白银", "张掖", "酒泉", "武威", "平凉", "庆阳", "定西", "金昌", "嘉峪关"] },
  { name: "内蒙古", cities: ["呼和浩特", "包头", "鄂尔多斯", "赤峰", "通辽", "乌海", "呼伦贝尔", "兴安盟", "锡林郭勒", "阿拉善", "巴彦淖尔", "乌兰察布"] },
  { name: "新疆", cities: ["乌鲁木齐", "喀什", "克拉玛依", "阿克苏", "昌吉", "哈密", "伊犁", "吐鲁番", "和田", "巴音郭楞", "博尔塔拉"] },
  { name: "海南", cities: ["海口", "三亚", "三沙", "儋州"] },
  { name: "宁夏", cities: ["银川", "吴忠", "固原", "石嘴山", "中卫"] },
  { name: "青海", cities: ["西宁", "海东", "海南", "海北", "果洛", "玉树", "海西", "黄南"] },
  { name: "西藏", cities: ["拉萨", "日喀则", "昌都", "林芝", "山南", "那曲", "阿里"] },
];

const ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ".split("").filter(l => CITIES_BY_LETTER[l]);

interface CityPickerProps {
  city: string;
  onSelect: (city: string) => void;
}

export default function CityPicker({ city, onSelect }: CityPickerProps) {
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState<"letter" | "province">("letter");
  const [searchInput, setSearchInput] = useState("");
  const [activeLetter, setActiveLetter] = useState("A");
  const [defaultCity, setDefaultCity] = useState("北京");
  const [locating, setLocating] = useState(false);
  const [activeProvince, setActiveProvince] = useState("广东");
  const listRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Auto-detect city on mount
  useEffect(() => {
    handleLocate(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Close on outside click
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleLocate = (silent = false) => {
    if (!silent) setLocating(true);
    // Simulate geolocation
    setTimeout(() => {
      const detected = "南京";
      onSelect(detected);
      if (!silent) setLocating(false);
    }, 800);
  };

  const handleSelect = (c: string) => {
    onSelect(c);
    setOpen(false);
    setSearchInput("");
  };

  const handleSetDefault = () => {
    setDefaultCity(city);
  };

  const scrollToLetter = (letter: string) => {
    setActiveLetter(letter);
    const el = listRef.current?.querySelector(`[data-letter="${letter}"]`);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const filteredCities = searchInput.trim()
    ? Object.values(CITIES_BY_LETTER).flat().filter(c => c.includes(searchInput.trim()))
    : [];

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Trigger button */}
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 bg-white border border-slate-200 rounded-lg px-3 py-2.5 text-sm text-slate-800 hover:text-slate-900 hover:border-blue-400 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-map-pin-line text-blue-500 text-sm"></i>
        {city}
        <i className={`ri-arrow-down-s-line text-slate-500 transition-transform duration-200 ${open ? "rotate-180" : ""}`}></i>
      </button>

      {/* Dropdown panel */}
      {open && (
        <div className="absolute top-11 left-0 w-[540px] bg-white border border-slate-200 rounded-xl z-50 overflow-hidden" style={{ boxShadow: "0 8px 32px rgba(0,0,0,0.12)" }}>
          {/* Header: current city & default */}
          <div className="bg-blue-50/60 border-b border-blue-100 px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-4 text-sm">
              <span className="text-slate-600">当前城市：
                <span className="text-blue-600 font-semibold ml-1">{city}</span>
              </span>
              <span className="text-slate-300">|</span>
              <span className="text-slate-600">默认城市：
                <span className="text-slate-800 font-semibold ml-1">{defaultCity}</span>
                <button
                  onClick={handleSetDefault}
                  className="ml-1.5 text-xs text-blue-500 hover:text-blue-700 cursor-pointer transition-colors whitespace-nowrap"
                >[设为默认]</button>
              </span>
            </div>
            <button
              onClick={() => handleLocate(false)}
              className="flex items-center gap-1 text-xs text-blue-500 hover:text-blue-700 cursor-pointer transition-colors whitespace-nowrap"
            >
              {locating
                ? <><i className="ri-loader-4-line animate-spin"></i> 定位中...</>
                : <><i className="ri-map-pin-2-line"></i> 重新定位</>
              }
            </button>
          </div>

          {/* My cities */}
          <div className="px-4 py-3 border-b border-slate-100">
            <div className="text-xs text-slate-600 font-semibold mb-2">我的城市</div>
            <div className="flex flex-wrap gap-1.5">
              {MY_CITIES.map(c => (
                <button
                  key={c}
                  onClick={() => handleSelect(c)}
                  className={`px-3 py-1 rounded text-xs cursor-pointer transition-colors whitespace-nowrap ${
                    city === c
                      ? "bg-blue-500 text-white font-medium"
                      : "bg-white border border-slate-300 text-slate-800 hover:border-blue-400 hover:text-blue-600"
                  }`}
                >
                  {c}
                </button>
              ))}
            </div>
          </div>

          {/* Tab + search */}
          <div className="px-4 pt-3 pb-0 flex items-center gap-0 border-b border-slate-100">
            <div className="flex">
              <button
                onClick={() => setTab("letter")}
                className={`px-4 py-2 text-sm cursor-pointer transition-colors whitespace-nowrap border-b-2 ${
                  tab === "letter" ? "text-blue-600 border-blue-500 font-semibold" : "text-slate-500 border-transparent hover:text-slate-800"
                }`}
              >
                按城市
              </button>
              <button
                onClick={() => setTab("province")}
                className={`px-4 py-2 text-sm cursor-pointer transition-colors whitespace-nowrap border-b-2 ${
                  tab === "province" ? "text-blue-600 border-blue-500 font-semibold" : "text-slate-500 border-transparent hover:text-slate-800"
                }`}
              >
                按省份
              </button>
            </div>
            <div className="ml-auto mb-2 flex items-center border border-slate-200 rounded overflow-hidden bg-white">
              <input
                type="text"
                value={searchInput}
                onChange={e => setSearchInput(e.target.value)}
                placeholder="输入城市名"
                className="text-xs text-slate-800 placeholder-slate-400 px-2.5 py-1.5 outline-none w-28"
              />
              <button className="px-2 py-1.5 text-slate-400 hover:text-blue-500 cursor-pointer">
                <i className="ri-search-line text-sm"></i>
              </button>
            </div>
          </div>

          {/* Search results */}
          {searchInput.trim() && (
            <div className="px-4 py-3 flex flex-wrap gap-1.5 max-h-40 overflow-y-auto border-b border-slate-100">
              {filteredCities.length > 0 ? filteredCities.map(c => (
                <button
                  key={c}
                  onClick={() => handleSelect(c)}
                  className="px-3 py-1 rounded text-xs bg-white border border-slate-300 text-slate-800 hover:border-blue-400 hover:text-blue-600 cursor-pointer transition-colors whitespace-nowrap"
                >
                  {c}
                </button>
              )) : (
                <span className="text-xs text-slate-600">未找到匹配城市</span>
              )}
            </div>
          )}

          {/* City list by letter */}
          {!searchInput.trim() && tab === "letter" && (
            <div className="flex" style={{ height: "260px" }}>
              {/* Alphabet sidebar */}
              <div className="flex flex-col items-center py-2 px-1.5 border-r border-slate-100 overflow-y-auto bg-slate-50" style={{ minWidth: "32px" }}>
                {ALPHABET.map(l => (
                  <button
                    key={l}
                    onClick={() => scrollToLetter(l)}
                    className={`w-6 h-6 flex items-center justify-center text-xs rounded cursor-pointer transition-colors whitespace-nowrap mb-0.5 ${
                      activeLetter === l ? "bg-blue-500 text-white font-semibold" : "text-slate-600 hover:text-blue-600 hover:bg-blue-50"
                    }`}
                  >
                    {l}
                  </button>
                ))}
              </div>
              {/* City groups */}
              <div ref={listRef} className="flex-1 overflow-y-auto px-3 py-2">
                {ALPHABET.map(letter => (
                  <div key={letter} data-letter={letter} className="mb-3">
                    <div className="text-xs font-bold text-slate-700 mb-1.5 sticky top-0 bg-white pb-0.5 border-b border-slate-200">{letter}</div>
                    <div className="flex flex-wrap gap-1 pt-1">
                      {(CITIES_BY_LETTER[letter] || []).map(c => (
                        <button
                          key={c}
                          onClick={() => handleSelect(c)}
                          className={`px-2.5 py-0.5 rounded text-xs cursor-pointer transition-colors whitespace-nowrap ${
                            city === c
                              ? "bg-blue-500 text-white font-medium"
                              : "bg-white border border-slate-300 text-slate-800 hover:border-blue-400 hover:text-blue-600"
                          }`}
                        >
                          {c}
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* City list by province */}
          {!searchInput.trim() && tab === "province" && (
            <div className="flex" style={{ height: "260px" }}>
              {/* Province list */}
              <div className="overflow-y-auto border-r border-slate-100 py-1 bg-slate-50" style={{ minWidth: "90px" }}>
                {PROVINCES.map(p => (
                  <button
                    key={p.name}
                    onClick={() => setActiveProvince(p.name)}
                    className={`w-full text-left px-3 py-2 text-xs cursor-pointer transition-colors whitespace-nowrap ${
                      activeProvince === p.name
                        ? "text-blue-600 bg-white font-semibold border-r-2 border-blue-500"
                        : "text-slate-700 hover:bg-white hover:text-slate-900"
                    }`}
                  >
                    {p.name}
                  </button>
                ))}
              </div>
              {/* Cities of selected province */}
              <div className="flex-1 overflow-y-auto px-3 py-3">
                <div className="text-xs text-slate-600 font-semibold mb-2">{activeProvince} · 所有城市</div>
                <div className="flex flex-wrap gap-1.5">
                  {(PROVINCES.find(p => p.name === activeProvince)?.cities || []).map(c => (
                    <button
                      key={c}
                      onClick={() => handleSelect(c)}
                      className={`px-3 py-1 rounded text-xs cursor-pointer transition-colors whitespace-nowrap ${
                        city === c
                          ? "bg-blue-500 text-white font-medium"
                          : "bg-white border border-slate-300 text-slate-800 hover:border-blue-400 hover:text-blue-600"
                      }`}
                    >
                      {c}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
